import axios from 'axios';

import createUrlWithParams from 'helpers/createUrlWithParams';

import {
  parseActionInstanceStepCommentCreateForBE,
  parseActionInstanceStepCommentForFE,
  parseActionInstanceStepCommentListForFE,
  parseActionInstanceStepForFE,
  parsePatchActionInstanceStepForBE,
  parseStatusLogListForFE,
} from './actionInstanceStep.parsers';
import type {
  ActionInstanceStepCommentDTO,
  ActionInstanceStepDTO,
  ActionInstanceStepAPI,
  PaginatedCommentResponse,
  PaginatedStatusLogResponse,
  StatusLogDTO,
  StatusLogListParams,
} from './actionInstanceStep.types';

const endpoint = 'api/v1/action-instance-steps/';

const getCommentsUrl = (stepId: number, params?: { limit?: number; offset?: number }) =>
  createUrlWithParams(`${endpoint}${stepId}/comments/`, params || {});

const getStatusLogsUrl = (stepId: number, params?: StatusLogListParams) =>
  createUrlWithParams(`${endpoint}${stepId}/status-logs/`, params || {});

export const actionInstanceStepApi: ActionInstanceStepAPI = {
  getComments: async (stepId, params) => {
    const { data } = await axios.get(getCommentsUrl(stepId, params));
    const rawResults = Array.isArray(data) ? data : data.results || [];
    const results = rawResults as ActionInstanceStepCommentDTO[];
    return {
      data: {
        count: Array.isArray(data) ? data.length : data.count ?? results.length,
        next: Array.isArray(data) ? null : data.next ?? null,
        previous: Array.isArray(data) ? null : data.previous ?? null,
        results: parseActionInstanceStepCommentListForFE(results),
      } as PaginatedCommentResponse,
    };
  },

  createComment: async (stepId, payload) => {
    const { data } = await axios.post(`${endpoint}${stepId}/comments/`, parseActionInstanceStepCommentCreateForBE(payload));
    return { data: parseActionInstanceStepCommentForFE(data as ActionInstanceStepCommentDTO) };
  },

  getStatusLogs: async (stepId, params) => {
    const { data } = await axios.get(getStatusLogsUrl(stepId, params));
    const rawResults = Array.isArray(data) ? data : data.results || [];
    const results = rawResults as StatusLogDTO[];
    return {
      data: {
        count: Array.isArray(data) ? data.length : data.count ?? results.length,
        next: Array.isArray(data) ? null : data.next ?? null,
        previous: Array.isArray(data) ? null : data.previous ?? null,
        results: parseStatusLogListForFE(results),
      } as PaginatedStatusLogResponse,
    };
  },

  patchStep: async (stepId, payload) => {
    const { data } = await axios.patch(`${endpoint}${stepId}/`, parsePatchActionInstanceStepForBE(payload));
    return { data: parseActionInstanceStepForFE(data as ActionInstanceStepDTO) };
  },
};

export default actionInstanceStepApi;
